import React, { createContext, useEffect, useState } from 'react';
import api from '@services/api';

export const AdminContext = createContext();

export default function AdminProvider({ children }) {
  const [data, setData] = useState({
    name: '',
    isMerchantAdmin: false,
    showModal: false,
    isCardsRenewal: false,
    currentUserEmail: '',
    canCreateCustomer: false,
    canShowCustomersImport: false,
  });
  useEffect(() => {
    api.get('/admin/user_context_info').then((response) => {
      setData({
        name: response.data?.name,
        isMerchantAdmin: response.data?.merchant?.admin,
        showModal: response.data?.merchant?.show_modal,
        isCardsRenewal: response.data?.merchant?.cards_renewal_toggle,
        currentUserEmail: response.data?.user?.email,
        canCreateCustomer: response.data?.user?.can_create_customer,
        canShowCustomersImport: response.data?.user?.can_show_customers_import,
      });
    });
  }, []);

  function hiddenModal() {
    setData((old) => ({ ...old, showModal: false }));
  }

  return (
    <AdminContext.Provider value={{ ...data, hiddenModal }}>
      {children}
    </AdminContext.Provider>
  );
}
